import { useEffect, useState } from 'react'

export interface BannerData {
  screen: string
  isActive: boolean
  message: string
  bannerType: 'warning' | 'info'
}

export function useBanner(screen: string): BannerData | null {
  const [banner, setBanner] = useState<BannerData | null>(null)

  useEffect(() => {
    const controller = new AbortController()
    fetch(`/api/admin/banner?screen=${encodeURIComponent(screen)}`, { signal: controller.signal })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        setBanner(d?.isActive ? d : null)
      })
      .catch(() => {})
    return () => controller.abort()
  }, [screen])

  return banner
}
